import { isNOU } from '@/plugins/common/expansions/condition'

export default (v) => {
  return isNOU(v) || isNaN(Number(v)) ? undefined : Number(v)
}
